'use client';

var _excluded = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className", "disabled", "disableRipple", "slots", "slotProps", "inputProps"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import clsx from 'clsx';
import refType from '@mui/utils/refType';
import composeClasses from '@mui/utils/composeClasses';
import { alpha } from '@mui/system/colorManipulator';
import SwitchBase from "../internal/SwitchBase.js";
import RadioButtonIcon from "./RadioButtonIcon.js";
import capitalize from "../utils/capitalize.js";
import createChainedFunction from "../utils/createChainedFunction.js";
import useFormControl from "../FormControl/useFormControl.js";
import useRadioGroup from "../RadioGroup/useRadioGroup.js";
import radioClasses, { getRadioUtilityClass } from "./radioClasses.js";
import rootShouldForwardProp from "../styles/rootShouldForwardProp.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import useSlot from "../utils/useSlot.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    color = ownerState.color,
    size = ownerState.size;
  var slots = {
    root: ['root', "color".concat(capitalize(color)), size !== 'medium' && "size".concat(capitalize(size))]
  };
  return _objectSpread(_objectSpread({}, classes), composeClasses(slots, getRadioUtilityClass, classes));
};
var RadioRoot = styled(SwitchBase, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return rootShouldForwardProp(prop) || prop === 'classes';
  },
  name: 'MuiRadio',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.size !== 'medium' && styles["size".concat(capitalize(ownerState.size))], styles["color".concat(capitalize(ownerState.color))]];
  }
})(memoTheme(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty(_defineProperty({
    color: (theme.vars || theme).palette.text.secondary
  }, "&.".concat(radioClasses.disabled), {
    color: (theme.vars || theme).palette.action.disabled
  }), "variants", [{
    props: {
      color: 'default',
      disabled: false,
      disableRipple: false
    },
    style: {
      '&:hover': {
        backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.activeChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
      }
    }
  }].concat(_toConsumableArray(Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
      color = _ref3[0];
    return {
      props: {
        color: color,
        disabled: false,
        disableRipple: false
      },
      style: {
        '&:hover': {
          backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
        }
      }
    };
  })), _toConsumableArray(Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
      color = _ref5[0];
    return {
      props: {
        color: color,
        disabled: false
      },
      style: _defineProperty({}, "&.".concat(radioClasses.checked), {
        color: (theme.vars || theme).palette[color].main
      })
    };
  })), [{
    // Should be last to override other colors
    props: {
      disableRipple: false
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      '&:hover': {
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }
  }]));
}));
function areEqualValues(a, b) {
  if (_typeof(b) === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
var defaultCheckedIcon = /*#__PURE__*/_jsx(RadioButtonIcon, {
  checked: true
});
var defaultIcon = /*#__PURE__*/_jsx(RadioButtonIcon, {});
var Radio = /*#__PURE__*/React.forwardRef(function Radio(inProps, ref) {
  var _slotProps$input, _icon$props$fontSize, _checkedIcon$props$fo;
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiRadio'
  });
  var checkedProp = props.checked,
    _props$checkedIcon = props.checkedIcon,
    checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? defaultIcon : _props$icon,
    nameProp = props.name,
    onChangeProp = props.onChange,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    className = props.className,
    disabledProp = props.disabled,
    _props$disableRipple = props.disableRipple,
    disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    inputProps = props.inputProps,
    other = _objectWithoutProperties(props, _excluded);
  var muiFormControl = useFormControl();
  var disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }
  disabled !== null && disabled !== void 0 ? disabled : disabled = false;
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled,
    disableRipple: disableRipple,
    color: color,
    size: size
  });
  var classes = useUtilityClasses(ownerState);
  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var _onChange = createChainedFunction(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = areEqualValues(radioGroup.value, props.value);
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  var externalInputProps = (_slotProps$input = slotProps.input) !== null && _slotProps$input !== void 0 ? _slotProps$input : inputProps;
  var _useSlot = useSlot('root', {
      ref: ref,
      elementType: RadioRoot,
      className: clsx(classes.root, className),
      shouldForwardComponentProp: true,
      externalForwardedProps: _objectSpread({
        slots: slots,
        slotProps: slotProps
      }, other),
      getSlotProps: function getSlotProps(handlers) {
        return _objectSpread(_objectSpread({}, handlers), {}, {
          onChange: function onChange(event) {
            var _handlers$onChange;
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            (_handlers$onChange = handlers.onChange) === null || _handlers$onChange === void 0 || _handlers$onChange.call.apply(_handlers$onChange, [handlers, event].concat(args));
            _onChange.apply(void 0, [event].concat(args));
          }
        });
      },
      ownerState: ownerState,
      additionalProps: {
        type: 'radio',
        icon: /*#__PURE__*/React.cloneElement(icon, {
          fontSize: (_icon$props$fontSize = icon.props.fontSize) !== null && _icon$props$fontSize !== void 0 ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/React.cloneElement(checkedIcon, {
          fontSize: (_checkedIcon$props$fo = checkedIcon.props.fontSize) !== null && _checkedIcon$props$fo !== void 0 ? _checkedIcon$props$fo : size
        }),
        disabled: disabled,
        name: name,
        checked: checked,
        slots: slots,
        slotProps: {
          // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
          input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
        }
      }
    }),
    _useSlot2 = _slicedToArray(_useSlot, 2),
    RootSlot = _useSlot2[0],
    rootSlotProps = _useSlot2[1];
  return /*#__PURE__*/_jsx(RootSlot, _objectSpread(_objectSpread({}, rootSlotProps), {}, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Radio;